import models from '@/nebula/models';

export const initState = () => models.reduce((res, next) => {
  res[next] = {};
  return res;
}, {});
